import { render, staticRenderFns } from "./CurrencyDropdownMenu.vue?vue&type=template&id=bff3e352&"
import script from "./CurrencyDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./CurrencyDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyDropdownMenu.vue?vue&type=style&index=0&id=bff3e352&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports